import { type FC, type PropsWithChildren, createContext, useContext } from "react";

import { ConfigKeys, getDefaultConfig } from "~/utils/config";

export interface ConfigContextType {
	isCollabEditingEnabled: boolean;
}

const isCollabEditingDefault = getDefaultConfig(ConfigKeys.COLLAB_EDITING);

const ConfigContext = createContext<ConfigContextType>({
	isCollabEditingEnabled: isCollabEditingDefault,
});

export const useConfig = () => useContext(ConfigContext);

export const ConfigProvider: FC<PropsWithChildren> = ({ children }) => {
	const value = { isCollabEditingEnabled: false };

	return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
};
